export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-mail-send-line"></i>意见反馈
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto mb-8">
            如有内容建议、资源反馈或合作意向，欢迎随时与我们联系
          </p>

          <div className="bg-background-50 rounded-xl p-6 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-medium text-foreground-900 text-sm mb-1">电子邮箱</h3>
                <span className="text-sm text-foreground-500">feedback@51cinema.com</span>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="font-medium text-foreground-900 text-sm mb-1">微信公众号</h3>
                <span className="text-sm text-foreground-500">51影院官方</span>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-3">
                  <i className="ri-question-answer-line text-xl"></i>
                </div>
                <h3 className="font-medium text-foreground-900 text-sm mb-1">在线反馈</h3>
                <span className="text-sm text-foreground-500">工作日 9:00-18:00</span>
              </div>
            </div>

            <form className="max-w-lg mx-auto text-left" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">昵称</label>
                  <input
                    type="text"
                    name="nickname"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="你的昵称"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-foreground-700 mb-1.5">反馈内容</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="请描述你的意见或建议（500字以内）"
                ></textarea>
              </div>
              <input type="text" name="website_alt" className="hp-field" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              <button
                type="submit"
                className="w-full px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                提交反馈
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}